import { useMatch } from 'react-router';

import Stepper from 'honeydew/Stepper';

export const Step = Object.freeze({
    ACCOUNT: 'account',
    DELIVERY: 'delivery',
    PAYMENT: 'payment',
});

const OrderedSteps = Object.freeze([Step.ACCOUNT, Step.DELIVERY, Step.PAYMENT]);

function CreateAccountProgress() {
    const match = useMatch('/join/:activeStep');
    const { activeStep } = match?.params ?? {};
    const activeStepIndex = OrderedSteps.findIndex((step) => step === activeStep);

    const getStatus = ({ index }) => {
        if (index === activeStepIndex) {
            return 'in progress';
        }

        if (index < activeStepIndex) {
            return 'done';
        }

        return 'upcoming';
    };

    return (
        <div className="text-body-mobile-md">
            <Stepper
                containerWidth="100%"
                size="small"
                steps={[
                    {
                        id: Step.ACCOUNT,
                        name: 'Account',
                        status: getStatus({ index: 0 }),
                        subtext: '',
                        link: '/join/account',
                    },
                    {
                        id: Step.DELIVERY,
                        name: 'Delivery',
                        status: getStatus({ index: 1 }),
                        subtext: '',
                        link: '/join/delivery',
                    },
                    {
                        id: Step.PAYMENT,
                        name: 'Payment',
                        status: getStatus({ index: 2 }),
                        subtext: '',
                        link: '/join/payment',
                    },
                ]}
            />
        </div>
    );
}

export default CreateAccountProgress;
